import * as React from 'react';
import MuiListItemButton from '@mui/material/ListItemButton';
import MuiListItemIcon from '@mui/material/ListItemIcon';
import MuiListItemText from '@mui/material/ListItemText';
import ExpandMore from '@mui/icons-material/ExpandMore';
import ExpandLess from '@mui/icons-material/ExpandLess';
import { Link as RouterLink, LinkProps as RouterLinkProps } from 'react-router-dom';
import { NavProps } from '../data';
import RestrictedAccess from '../../RestrictedAccess';

interface Props {
  isLink: boolean;
  open: boolean;
  item: NavProps;
  selected: boolean;
  handleClick: React.MouseEventHandler<HTMLAnchorElement>;
  isSubItem?: boolean;
}

export default function ListItemButton({
  isLink,
  open,
  item,
  selected,
  handleClick,
  isSubItem,
}: Props) {
  const renderLink = React.useMemo(
    () =>
      React.forwardRef<HTMLAnchorElement, Omit<RouterLinkProps, 'to'>>(function Link(
        itemProps,
        ref,
      ) {
        return <RouterLink to={item.to} ref={ref} {...itemProps} role={undefined} />;
      }),
    [item.to],
  );

  return item.claimType && item.claimValue ? (
    <RestrictedAccess type={item.claimType} value={item.claimValue} showAlert={false}>
      <MuiListItemButton
        component={isLink ? renderLink : 'button'}
        onClick={handleClick}
        selected={selected}
        sx={{ pl: isSubItem ? 3 : undefined, width: '95%' }}
      >
        <MuiListItemIcon>{item.icon}</MuiListItemIcon>
        <MuiListItemText primary={item.primary} primaryTypographyProps={{ fontSize: 12 }} />
        {!isLink ? open ? <ExpandLess /> : <ExpandMore /> : ''}
      </MuiListItemButton>
    </RestrictedAccess>
  ) : (
    <MuiListItemButton
      component={isLink ? renderLink : 'button'}
      onClick={handleClick}
      selected={selected}
      sx={{ pl: isSubItem ? 3 : undefined, width: '95%' }}
    >
      <MuiListItemIcon>{item.icon}</MuiListItemIcon>
      <MuiListItemText primary={item.primary} primaryTypographyProps={{ fontSize: 12 }} />
      {!isLink ? open ? <ExpandLess /> : <ExpandMore /> : ''}
    </MuiListItemButton>
  );
}
